import request from '../helpers/request';

const deleteRequestComment = async (commentId) => {
  return await request.delete(
    `/Request/note/${commentId}`,
    {},
    'Не удалось удалить комментарий'
  );
};

export default deleteRequestComment;
